module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-nw.956763d9.png";